import { DROPZONE_VIDEO_FORMATS } from '@/shared/config';

const videoExtensions = Object.values(DROPZONE_VIDEO_FORMATS).flat();

export const isVideoFile = (file: File): boolean => {
  if (file.type.startsWith('video/')) {
    return true;
  }

  const lowerCaseName = file.name.toLowerCase();

  return videoExtensions.some((extension) =>
    lowerCaseName.endsWith(extension.toLowerCase()),
  );
};
